import { isEmpty } from 'lodash';
import { mapState } from 'vuex';
import Contextmenu from '../../chart/Contextmenu.vue';

export default {
  components: {
    Contextmenu,
  },
  data() {
    return {
      contextmenuParam: {
        show: false,
        x: 0,
        y: 0,
        items: [],
      },
    };
  },
  computed: {
    ...mapState('common/menu', ['realtime']),
    ...mapState('common/system', ['system']),
    menus() {
      const [{ children: realtimeMenus }] = this.realtime;
      const [{ children: menus }] = realtimeMenus.filter(m => m.name == this.system.stackType.toLowerCase());
      return menus;
    },
  },
  methods: {
    // Modified.by.KWShin.2022.12.15.패러미터 xAxisValue를 추가함.
    onContextmenuChart(event, selectedDescendant, xAxisValue) {
      event.preventDefault();
      const menu = this.menus.find(menu => menu.url == this.contextmenuUrl);
      if (!menu) return;
      const descendantQuery = isEmpty(selectedDescendant) ? '' : `&d=${selectedDescendant.id}`;
      // Added.by.KWShin.2022.12.15.상수 dtQuery를 추가함.
      const dtQuery = isEmpty(xAxisValue) ? '' : `&t=${new Date(xAxisValue).getTime()}`;
      this.contextmenuParam = {
        show: true,
        x: event.clientX,
        y: event.clientY,
        items: [
          {
            icon: menu.icon,
            text: this.$t(menu.messageCode),
            // Modified.by.KWShin.2022.12.15.URLParameter에 dtQuery를 추가함.
            handler: () => window.open(`${menu.url}/${this.system.id}?${descendantQuery}${dtQuery}`, '_blank'),
          },
        ],
      };
    },
  },
};
